export default __webpack_public_path__ + "static/media/icone-termometro.bd077b2a.svg";